import React from "react";
import { motion } from "framer-motion";

/**
 * Centred section heading used across the Home page.
 * The brand-orange rule sits directly beneath the heading; pass `rule={false}`
 * to drop it for a section that reads better without.
 */
const SectionHeading = ({
  id,
  title,
  subtitle,
  subtitleAs: SubtitleTag = "h3",
  subtitleClassName = "mx-auto max-w-2xl text-lg md:text-xl font-bold text-gray-900",
  rule = true,
  className = "mb-10 lg:mb-14",
}) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.5, ease: "easeOut" }}
    className={`text-center ${className}`}
  >
    <h2
      id={id}
      className="text-center text-3xl md:text-4xl font-extrabold tracking-tight text-[var(--brand-primary)] drop-shadow-sm"
    >
      {title}
    </h2>
    {rule && (
      <div className="mx-auto mt-3 h-1 w-40 rounded-full bg-[var(--brand-orange)]" />
    )}
    {subtitle && (
      <SubtitleTag className={`mt-5 ${subtitleClassName}`}>
        {subtitle}
      </SubtitleTag>
    )}
  </motion.div>
);

export default SectionHeading;
